import rcss from '../../../Styles/reports.module.css';
import { observer } from "mobx-react-lite";
import { getTrackingDomainReportState } from "../getTrackingDomainReportState";
import { KnownTrackerView } from "./KnownTrackerView";
import { SearchTermsFound } from "../SearchResultsObserver";
import { ResultsForSearchTermView } from "./ResultsForOriginalSearchTermView";
import { EventsTableAnalysisResults } from '../EventsTableAnalysisResults';
import { InteractiveRequestIdBaseProps } from "../InteractiveRequestId";
import { GetsDbEventsByIndex } from "../../../State/EvidenceDB/DbEventCache";
import { HasCallStackResolution } from "../../../lib/Causation/CallStackResolution";
import { Literal } from "../../../Styles/ReportStyles";
import { UnlicensedText } from "../../../constants";
import { HasLicensePermissions } from "../../../State/EvidenceDB/LicensePermissions";

const DomainSearchResultsView = observer( (
	{
		searchTerms,
		...rest
}: InteractiveRequestIdBaseProps & HasCallStackResolution & HasLicensePermissions &  {
	getsDbEventsByIndex: GetsDbEventsByIndex;
	searchTerms?: SearchTermsFound;
}) => {
	if (searchTerms == null) return null;
	return (<>
		<h3>Data Transmitted</h3>
		{searchTerms.map((resultsForSearchTerm) => (
			<ResultsForSearchTermView key={resultsForSearchTerm.searchTermAsSpecified}
				{...{resultsForSearchTerm, ...rest}} />
		))
	}</>)
});

export const CookieSubsectionView = observer( ({cookies}: {cookies?: {name: string, value: string}[]}) => {
	if (cookies == null || cookies.length === 0) return null;
	return (<>
		<h3>Cookies</h3>
			<div className={rcss.indented}>{
			cookies.map( (cookie) => (
				<div className={rcss.cookieLine} key={cookie.name}><Literal>{cookie.name}={cookie.value}</Literal></div>
		))}</div>
	</>)
});


export const DataRecipientsReportView = observer(
	(props: HasCallStackResolution & InteractiveRequestIdBaseProps & EventsTableAnalysisResults & HasLicensePermissions & {
		getsDbEventsByIndex: GetsDbEventsByIndex
	}) => {
		const trackingSummaryReportState = getTrackingDomainReportState(props);
		return (<div className={rcss.report}>
			{trackingSummaryReportState.map( ({ sourceRegisteredDomain, resultsByDestinationRegisteredDomain }) => {
				const licenseRestrictionText = !props.licensePermissions.mayUseForCommercialPurposesAt({pageRegisteredDomain: sourceRegisteredDomain}) ?
					UnlicensedText : undefined;
				return (
					<main className={rcss.report} key={sourceRegisteredDomain}>
						<h1 data-license={licenseRestrictionText}>Data Sent from &#32;
							<span className={rcss.sizeAdjustedLowercaseLiteral}>{sourceRegisteredDomain}</span></h1>
						{resultsByDestinationRegisteredDomain.map(({
							cookies,
							destinationRegisteredDomain,
//							codeBehavior,
							searchResults,
							knownTracker,
						}) => {
							const organizationKnownAs = knownTracker?.organizationKnownAs;
							return (
								<section className={rcss.reportSection} key={`${destinationRegisteredDomain}\0${sourceRegisteredDomain}`}>
									<h2 data-license={licenseRestrictionText}>{ organizationKnownAs == null ? ( 
											<span className={rcss.sizeAdjustedLowercaseLiteral}>{destinationRegisteredDomain}</span>
										) : (<>
												{organizationKnownAs}&#32;
												<span className={rcss.sizeAdjustedLowercaseLiteral}>({destinationRegisteredDomain})</span>
										</>)
									}</h2>
									<KnownTrackerView knownTracker={knownTracker} />
									<CookieSubsectionView cookies={cookies} />
									{/* <CodeBehaviorView codeBehavior={codeBehavior} /> */}
									<DomainSearchResultsView {...props} searchTerms={searchResults?.searchTerms} />
								</section>
						)})}
					</main>
				);
			})}
		</div>);
	});

